import md5 from 'md5';
import RnStorageEnhance from '@qnpm/rn-storage-enhance';
import { DeviceInfo } from 'qunar-react-native';
import * as loginUtil from '../../Utils/loginUtil';
import RootStore, { RootStoreInterface } from '../../Store';
import { FILTER_DATA_MAP } from '../../Constant/filterBarData';
import { SearchResultStoreModel } from '../../Store/SearchResult';

const storage = new RnStorageEnhance('order_rn', 'orderCache');

const setCache = async (cacheParam: any, response: any, loadType: string) => {
    try {
        const { start, ...cacheKeys } = cacheParam;
        if (loadType === 'loadMore' && start > 100) {
            // 做多缓存10页
            return;
        }

        const key = md5(JSON.stringify(cacheKeys));

        const { status, data: { orderList = [] } = {} } = response;

        if (status === 0 && orderList && orderList.length) {
            let cacheData;
            if (loadType === 'loadMore') {
                cacheData = {
                    ...(await storage.getItem(key)),
                    [start]: response
                };
            } else {
                cacheData = {
                    [start]: response
                };
            }

            return await storage.setItem(key, cacheData, {
                day: 90
            });
        }
    } catch (err) {
    }
};

const getCache = async (cacheParam: any) => {
    try {
        const { start, ...cacheKeys } = cacheParam;
        const key = md5(JSON.stringify(cacheKeys));

        const cacheData = await storage.getItem(key);

        if (cacheData) {
            let response = cacheData[start];
            if (!response) {
                return undefined;
            }
            const { status, data: { orderList = [] } = {} } = response;
            // 删除掉所有的隐私订单
            let tempOrderList = orderList.filter((item:any)=>(!item.private));
            if (response && response.data && response.data.orderList) {
                response.data.orderList = tempOrderList;        
            }
            return response;
        }
    } catch (err) {
        return undefined;
    }
};

const deleteOrder = async (cacheParam: any, sysCode: string, orderNo: string) => {
    try {
        const { start, ...cacheKeys } = cacheParam;

        const key = md5(JSON.stringify(cacheKeys));

        const cacheData = await storage.getItem(key);

        const keys = Object.keys(cacheData);

        // 找到要删除的订单页面数和在数组中的位置
        let curRow;
        for (const item of keys) {
            const { data: { orderList = [] } = {} } = cacheData[item];
            let findFlag = false;
            for (let j = 0; j < orderList.length; j++) {
                let otem = orderList[j];
                if(otem.flightMerge){
                    let listData = otem.listData || [];
                    let findListFlag = false;
                    for (let k = 0; k < listData.length; k++){
                        let ltem = listData[k];
                        if (ltem.orderNo === orderNo && ltem.sysCode === sysCode) {
                            findListFlag = true;
                            break;
                        }
                    }
                    if (findListFlag) {
                        findFlag = true;
                        break;
                    }
                }
                if (otem.orderNo === orderNo && otem.sysCode === sysCode) {
                    findFlag = true;
                    break;
                }
            }
            if (findFlag) {
                curRow = item;
                break;
            }
        }

        // 找到了之后就把这个订单从数组中删除掉
        if (curRow !== undefined) {
            const newDataSource = cacheData[curRow].data.orderList.slice().filter((item:any) => {
                if(item.flightMerge){//删除订单
                    item.listData = item.listData.slice().filter((v:any) => (v.orderNo !== orderNo));
                }
                return item.orderNo !== orderNo;
            })
            cacheData[curRow].data.orderList = newDataSource;
            // 如果发现这页数据都删没了，就把这也数据整个删掉，并把下一页的数据的页面提前
            if (cacheData[curRow].data.orderList.length <= 0) {
                for (let i = 0; i < keys.length; i++) {
                    if (i >= Number(curRow)) {
                        cacheData[i] = cacheData[i + 1];
                    }
                }
                delete cacheData[keys.length - 1];
            }
        }
        // 重新存储
        return await storage.setItem(key, cacheData, {
            day: 90
        });
    } catch (err) {
        // console.log(err);
    }
};


const getCacheKey = async (rootStore: RootStoreInterface | SearchResultStoreModel) => {
    const userId = (await loginUtil.getUserInfo()).userID;
    const key = DeviceInfo.uid + userId + rootStore.uiState.businessValue;
    return md5(key);
}

const saveFirstScreenCache = async (rootStore: RootStoreInterface | SearchResultStoreModel, response: any) => {
    console.log(rootStore);
    if (rootStore.uiState.statusFilter !== 'all') {
        return;
    }

    return await storage.setItem(await getCacheKey(rootStore), response, {
        day: 30
    });
}

const getFirstScreenCache = async (rootStore: RootStoreInterface | SearchResultStoreModel) => {
    console.log(rootStore);
    if (rootStore.uiState.statusFilter !== 'all') {
        return undefined;
    }
    return await storage.getItem(await getCacheKey(rootStore));
}


export { setCache, getCache, deleteOrder, saveFirstScreenCache, getFirstScreenCache };
